export default __webpack_public_path__ + "static/media/csv.fc84883d.svg";